import React, { useLayoutEffect, useRef } from 'react';
import Container from './Container';
import useScrollAnimation, { useCounterAnimation } from '../hooks/useScrollAnimation';
import AnimatedWords from './AnimatedWords';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const AboutWhoWeAre = () => {
  const imageRef = useScrollAnimation('scroll-animate-left');
  const textRef = useScrollAnimation('scroll-animate-right');
  const { elementRef: statsRef, count } = useCounterAnimation(5);
  const containerRef = useRef(null);

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        defaults: { ease: 'power2.out' },
        scrollTrigger: {
          trigger: containerRef.current,
          start: 'top 75%',
          toggleActions: 'play none none none',
          once: true
        }
      });
      const headingWords = containerRef.current?.querySelectorAll('.who-we-are-text h2 [data-animated-word]');
      if (headingWords && headingWords.length) {
        tl.fromTo(headingWords, { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: 'power3.out', stagger: 0.06, clearProps: 'transform' }, 0);
      }
      const paras = containerRef.current?.querySelectorAll('.who-we-are-text p');
      if (paras && paras.length) {
        tl.fromTo(paras, { filter: 'blur(18px)', opacity: 0, y: 8 }, { filter: 'blur(0px)', opacity: 1, y: 0, duration: 0.6, stagger: 0.12 }, '>-0.05');
      }
    }, containerRef);
    return () => ctx.revert();
  }, []);

  return (
    <section id="about" className="about-who-we-are section" ref={containerRef}>
      <Container>
        <div className="who-we-are-content">
          <div ref={imageRef} className="who-we-are-image scroll-animate-left hover-scale">
            <img src="/images/about_us_image1.webp" alt="Timeline Express Truck" />
            <div className="stats-overlay">
              <div ref={statsRef} className="stat-box counter-animate hover-lift">
                <h3 className="text-2xl md:text-3xl lg:text-4xl"><span className="years-num">{count}</span><span className="years-plus">+</span></h3>
                <p className="text-sm md:text-base lg:text-lg">Years of Excellence in Logistics</p>
              </div>
            </div>
          </div>
          <div ref={textRef} className="who-we-are-text scroll-animate-right">
            <div className="container section-badge flex items-center gap-3 !text-[16px] !md:text-[20px] !px-1">
              <div className="badge-dot"></div>
              Who We Are
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl">
              <AnimatedWords auto={false} lines={["Driven by Speed, Defined by Trust"]} accentMap={[[2, 5]]} />
            </h2>
            <p className="intro text-sm md:text-base lg:text-lg">We specialize in delivering reliable, on-time, and technology-driven logistics solutions across India. From air to rail to road, we connect businesses with efficiency and precision, ensuring every shipment arrives "On Time Everywhere."</p>
            <p className="emphasis text-sm md:text-base lg:text-lg">With a robust partner network, a dedicated team, and transparent operations, Timeline Express LLP is redefining logistics through innovation and customer-first commitment.</p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AboutWhoWeAre;
